import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class BreadcrumbService {
  constructor () {}

  /**
   * @description sending event to customize last part of breadcrumb url. On app-component there's a cleanup emitter to reset default value
   * To reset need to send a null value
   * @type {(EventEmitter<string | null>)}
   * @memberof BreadcrumbService
   */
  public customizeTitleEvent: EventEmitter<string | null> = new EventEmitter();
}
